import { render } from "./AppCurrencyInput.vue?vue&type=template&id=0d90b7ae&bindings={\"modelValue\":\"props\",\"value\":\"options\"}"
import script from "./AppCurrencyInput.vue?vue&type=script&lang=js"
export * from "./AppCurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script